// 메일 본문 외부 이미지의 `http://` URL 을 `https://` 로 승격한다.
//
// 운영은 HTTPS(app.officemail.io) 라 본문의 `http://` 이미지는 mixed content 다.
// Firefox 는 CSP(img-src 에 http 없음)로 이를 차단하고, Chrome 은 자동으로 https 로
// 업그레이드해 표시하는 브라우저 불일치가 있다. sanitize 단계에서 https 로 통일하면
// 본문 이미지에 한정해(앱 전역 CSP 완화 없이) 두 브라우저 모두 CSP 를 통과한다.
// 원격 호스트가 https 를 지원하지 않으면 여전히 로드되지 않는다(그 경우는 프록시 필요).

const HTTP_PREFIX = /^http:\/\//i

export function upgradeInsecureUrl(url: string): string {
  return HTTP_PREFIX.test(url) ? url.replace(HTTP_PREFIX, 'https://') : url
}

// srcset 은 "url descriptor, url descriptor, ..." 형식. 각 항목의 URL 만 승격한다.
// http 가 없으면 원본을 그대로 반환해 data: URI 등 콤마 포함 값의 손상을 피한다.
export function upgradeInsecureSrcset(srcset: string): string {
  if (!HTTP_PREFIX.test(srcset) && !/,\s*http:\/\//i.test(srcset)) return srcset

  return srcset
    .split(',')
    .map((entry) => {
      const trimmed = entry.trim()
      if (trimmed === '') return entry
      const [url, ...descriptor] = trimmed.split(/\s+/)
      return [upgradeInsecureUrl(url), ...descriptor].join(' ')
    })
    .join(', ')
}
